import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";

// ─── フッターリンク定義（全パス小文字・App.js のルートと統一）──────
const LINKS = [
  { to: "/home#page-top",       label: "ホーム" },
  { to: "/about#page-top",      label: "会社概要" },
  { to: "/recruit#page-top",    label: "採用" },
  { to: "/policy#page-top",     label: "個人情報保護方針" },
  { to: "/termsofuse#page-top", label: "ご利用条件" },
  { to: "/contact#page-top",    label: "問い合わせ" },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-metallic py-4 mt-0">
      <div className="footer-bottom-glow" aria-hidden="true" />

      <Container className="footer-inner">

        {/* ── ロゴ ─────────────────────────────────────── */}
        <Row className="justify-content-center">
          <Col xs="auto" className="footer-logo-wrap">
            <Link to="/home#page-top" aria-label="ホームへ戻る">
              <img
                src={`${process.env.PUBLIC_URL}/logo.svg`}
                alt="株式会社ZENKYO"
                className="footer-logo"
              />
            </Link>
          </Col>
        </Row>

        {/* ── 装飾ライン ────────────────────────────────── */}
        <Row>
          <Col>
            <div className="footer-divider" aria-hidden="true">
              <span className="footer-divider-icon" />
            </div>
          </Col>
        </Row>

        {/* ── ナビリンク ────────────────────────────────── */}
        <Row>
          <Col>
            <Nav className="footer-nav justify-content-center">
              {LINKS.map((link) => (
                <Nav.Link key={link.to} as={Link} to={link.to}>
                  {link.label}
                </Nav.Link>
              ))}
            </Nav>
          </Col>
        </Row>

        {/* ── Copyright ─────────────────────────────────── */}
        <Row>
          <Col className="text-center copyright">
            Copyright &copy;{" "}
            <span className="zenkyo-light">ZENKYO</span>{" "}
            Corporation {currentYear}.
          </Col>
        </Row>

      </Container>
    </footer>
  );
}
